module.exports = __webpack_public_path__ + "img/church1.7b42e529.svg";